module.exports = __webpack_public_path__ + "img/BobaFett.2f2c177.png";